import { UserInfo } from '@/types/userInfo';
import { apiGetRequest } from '@/utils/apiClient';

/**
 * ユーザー情報取得
 * Context確認し、なければDBから取得
 * @param userInfo ユーザー情報
 * @param setUserInfo ユーザー情報セット関数
 * @param navigate ナビゲーション関数
 */
export async function ensureUserInfo(
    userInfo: UserInfo | null,
    setUserInfo: (info: UserInfo) => void,
): Promise<void> {
    // Contextにすでに存在するならリターン
    if (
        userInfo?.userId &&
        userInfo?.accountName &&
        userInfo?.accountImage &&
        userInfo?.email &&
        userInfo?.weekStart &&
        userInfo?.planName &&
        userInfo?.isPaid !== undefined &&
        userInfo?.referralActive !== undefined &&
        userInfo?.calendarList.length > 0
    )
        return;

    // なければ、DBから取得
    const res = await apiGetRequest('/api/user/info');
    if (!res?.ok) {
        // 401未認証エラーの場合
        if (res?.status === 401) {
            // ログインページにリダイレクト（履歴を残さない強制的なリダイレクト）
            window.location.replace('/login?error=unauthorized');
            return;
        }
        // ログインページにリダイレクト（履歴を残さない強制的なリダイレクト）
        window.location.replace('/login?error=server_error');
        return;
    }

    const json = await res?.json();
    const fetchedUser: UserInfo = {
        userId: json.userId,
        accountName: json.accountName,
        accountImage: json.accountImage,
        email: json.email,
        language: json.language,
        locale: json.locale,
        weekStart: json.weekStart,
        timeZone: json.timeZone,
        planName: json.planName,
        isPaid: json.isPaid,
        referralActive: json.referralActive,
        isNewlyRegistered: json.isNewlyRegistered,
        calendarList: json.calendarList,
        birthYear: json.birthYear ?? null,
    };
    // Contextに保存
    setUserInfo(fetchedUser);
}
